module.exports = __webpack_public_path__ + "static/media/CONTRAT_ELEVE_CLIENT.61fa7a51.pdf";